import { render, staticRenderFns } from "./SidebarAddPICBranch.vue?vue&type=template&id=1a2a516e&scoped=true"
import script from "./SidebarAddPICBranch.vue?vue&type=script&lang=js"
export * from "./SidebarAddPICBranch.vue?vue&type=script&lang=js"
import style0 from "./SidebarAddPICBranch.vue?vue&type=style&index=0&id=1a2a516e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a516e",
  null
  
)

export default component.exports